import { createContentDeliveryClient } from './axiosClient';

interface ContentParams {
	contentId: string;
	lang?: string;
}

export const getContentWithChildren = async ({
	contentId,
	lang = 'en',
}: ContentParams) => {
	const client = createContentDeliveryClient({
		headers: {
			'Accept-Language': lang,
		},
	});
	const response = await client.get(`${encodeURIComponent(contentId)}`, {
		params: {
			'Accept-Language': lang,
			expand: '*',
		},
	});
	return response.data;
};

export const getChildren = async ({
	contentId,
	lang = 'en',
}: ContentParams) => {
	const client = createContentDeliveryClient({
		headers: {
			'Accept-Language': lang,
		},
	});
	const response = await client.get(
		`${encodeURIComponent(contentId)}/children`,
		{
			params: {
				'Accept-Language': lang,
			},
		},
	);
	return response.data;
};
